// src/utils.ts

/**
 * Trunca el texto si supera la longitud especificada y agrega puntos suspensivos.
 * @param text - Cadena de texto que se desea truncar
 * @param maxLength - Número máximo de caracteres permitidos antes de truncar
 * @returns El texto truncado con "..." si excede la longitud, o el texto original si no
 */
export function truncateText(text: string, maxLength: number = 50): string {
  if (!text) return '';
  return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
}

export function fixEncodingIssues(text: string): string {
  if (!text) return '';

  return text
    .replace(/\u00e2\u0080\u0093/g, '– ')
    .replace(/\u00e2\u0080\u0094/g, '— ')
    .replace(/\u00e2\u0080\u0098/g, '‘ ')
    .replace(/\u00e2\u0080\u0099/g, '’ ')
    .replace(/\u00e2\u0080\u009c/g, '“ ')
    .replace(/\u00e2\u0080\u009d/g, '” ');
}

export const formatTreatment = (treatment: string[]): string => {
  return treatment.map((item) => item.replace(/^Drug:\s*/, '')).join(', ');
};

export const sortOptions = (options: string[]): string[] => {
  return [...options].sort((a, b) => a.localeCompare(b, 'en', { sensitivity: 'base' }));
};
